import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import axios from 'axios';
var DEFAULT_CONFIG = {
    userPhotoServiceEnabled: true
};
var configPromise = null;
export function getClientConfig() {
    if (!configPromise) {
        configPromise = axios.get('/api/client-config').then(function(res) {
            var _ref;
            return _object_spread({}, DEFAULT_CONFIG, (_ref = res === null || res === void 0 ? void 0 : res.data) !== null && _ref !== void 0 ? _ref : {});
        }).catch(function() {
            // Don't pin the session to defaults on a transient failure — clear the memo so the next call retries.
            configPromise = null;
            return DEFAULT_CONFIG;
        });
    }
    return configPromise;
}
